    import { useState } from "react";
    import {
    Avatar,
    Box,
    Menu,
    MenuItem,
    Typography,
    ListItemIcon,
    Divider,
    } from "@mui/material";
    import ArrowDown2 from "iconsax-reactjs/dist/esm/ArrowDown2.js";
    import Category2 from "iconsax-reactjs/dist/esm/Category2.js";
    import Setting2 from "iconsax-reactjs/dist/esm/Setting2.js";
    import LogoutCurve from "iconsax-reactjs/dist/esm/LogoutCurve.js";
    import { useDispatch } from "react-redux";
    import { logout } from "../../../../store/Slice/reducers";
    import { useMuiToast } from "../../../../Components/MuiToastProvider";
    import { useNavigate } from "react-router-dom";

    export default function ProfileMenu({ name, initials, profileImage }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { showToast } = useMuiToast();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = (e) => setAnchorEl(e.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleLogout = () => {
        handleClose();
        dispatch(logout());
        showToast("با موفقیت از حساب کاربری خود خارج شدید", "success");
    };

    return (
        <>
        <Box
            onClick={handleOpen}
            sx={{
            display: "flex",
            direction: "rtl",
            alignItems: "center",
            gap: 1,
            bgcolor: "#fff",
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 999,
            pl: 1.5,
            pr: 0.75,
            py: 0.6,
            cursor: "pointer",
            }}
        >
            <Box
            sx={{
                width: 34,
                height: 34,
                borderRadius: "50%",
                p: "2px",
                background: (t) =>
                `conic-gradient(from 180deg, ${t.palette.info.main}, ${t.palette.secondary.main}, ${t.palette.info.main})`,
            }}
            >
            {profileImage ? (
                <Box
                sx={{
                    width: 30,
                    height: 30,
                    borderRadius: "50%",
                    overflow: "hidden",
                    flexShrink: 0,
                }}
                >
                <img
                    src={import.meta.env.VITE_FILE_API + profileImage}
                    style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                    }}
                    alt={name}
                />
                </Box>
            ) : (
                <Avatar
                sx={{
                    width: 30,
                    height: 30,
                    fontSize: 12,
                    fontWeight: 700,
                    border: "2px solid #fff",
                }}
                >
                {initials}
                </Avatar>
            )}
            </Box>
            <Typography
            sx={{ display: { xs: "none", md: "block" } }}
            fontSize={13.5}
            fontWeight={600}
            >
            {name}
            </Typography>
            <ArrowDown2 size={14} color="#64748B" />
        </Box>

        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
            slotProps={{
            paper: {
                elevation: 0,
                sx: {
                direction: "rtl",
                mt: 1.5,
                minWidth: 190,
                borderRadius: 3,
                border: "1px solid",
                borderColor: "divider",
                boxShadow: "0 20px 40px -14px rgba(15,23,42,.25)",
                },
            },
            }}
        >
            <MenuItem
            onClick={() => {
                navigate("/profile/details");
            }}
            sx={{ borderRadius: 1.5, mx: 0.5, my: 0.25 }}
            >
            <ListItemIcon>
                <Category2 size={17} />
            </ListItemIcon>
            پنل کاربری
            </MenuItem>
            {/* <MenuItem
            onClick={handleClose}
            sx={{ borderRadius: 1.5, mx: 0.5, my: 0.25 }}
            >
            <ListItemIcon>
                <Setting2 size={17} />
            </ListItemIcon>
            تنظیمات
            </MenuItem> */}
            <Divider sx={{ my: 0.5 }} />
            <MenuItem
            onClick={handleLogout}
            sx={{ borderRadius: 1.5, mx: 0.5, my: 0.25, color: "error.main" }}
            >
            <ListItemIcon>
                <LogoutCurve size={17} color="#FF3737" />
            </ListItemIcon>
            خروج
            </MenuItem>
        </Menu>
        </>
    );
    }
